var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIfttt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern30",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_70_920",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_70_920",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAKRSURBVHhe7dmxahRRGAXgeQ8xMdZWFtqIia2FJiHbpBBLQRCLVAar9KkEnyBNan0BE3vfJWq5owN3llk518wmuxDC98GBwN7/v5ndA1tsAwAAAAAAAAAAAAAAAAAAAAAAAAAA3ASbZ+1kTLa+TR+XkTkPXn84/l/e7L780uVo7/nni521yaIp1zS/J/fX0ut9TvaeHvZ3XZbubNrRp7urXNuk14dJ+1Mue/5fL+7M3t/u73SmT7cr3ZGS5odpts7bdkw2z6cn5f+bs7Gx0Y7J24f32p87awunXNNc7K7vp9f7nG6tx3tTurNpR5/urnJtk14fJu1PufT5t+/O3t/u73impNuV7khJ88MoQIgChChATtqfogAKEOdnUYCcco0CDKIAIQqQk+aHUYAQBQhRgJy0P0UBFCDOz6IAOeUaBRhEAUIUICfND6MAIQoQogA5aX/KrS1AOptSm1+WZ2fT/XRvSne2jF1b2p+yzOfvdqU7UspIXRpKUYAs7U+5tQV4dPy1/TfbHz+1rw6O5vL+4PBH+j26z/D38KtQgJwyUpeGUmoPkL53Uhb5DrwKBcgpI3VpKEUBsrQ/RQEUQAHiB99HAUZTgEABcspIXRpKUYAs7U9RAAVQgPjB91GA0RQgUICcMlKXhlIUIEv7UxRAARQgfvB9FGA0BQgUIKeM1KWhlNoDpLMpy3wDEgXIKSN1aShFAbK0P0UBFEAByshKKEBOGalLQykKkKX9KQqgAApQRlZCAXLKSF0aSlGALO1PUQAFUIAyshIKkFNG6v4eOh2V79N3ZWROPJtSmV+WzbP2Sbw3pDtbxq4t7Y9Z4vN3u+IdIWUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJunaf4A5uqMDnoZwU0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfttt);
export default __webpack_public_path__ + "static/media/ifttt.d607ccbe5a521efb08dcffe62e230e52.svg";
export { ForwardRef as ReactComponent };